export default function offerDescriptionOptionsResolver({ offer }) {
    return {
        bind: {
            snippet: offer.snippet,
        },
    };
}